/* eslint-disable */
import SuperAdminService from "@/services/SuperAdminService";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";
import moment from "moment";
import GroupTalkService from "@/services/GroupTalkService";

export const useSuperAdminStore = defineStore("SuperAdminStore", {
  state: () => ({
    talks: [],

    talkTypes: [
      {
        id: 1,
        type: "text",
        button_name: "TEXT",
      },

      {
        id: 2,
        type: "video",
        button_name: "VIDEO",
      },

      // {
      //   id: 3,
      //   type: "pdf",
      //   button_name: "PDF",
      // },
    ],

    showCreateNewTalkModal: false,

    post: {
      content_type: "",
      title: "",
      body: "",
    },

    postDetails: {},

    textPost: {},

    showVideoEmbedModal: false,

    videoPost: {
      content_type: "",
      title: "",
      video_embed_code: "",
    },

    currentTalk: {},

    showPreviewTalkModal: false,

    managers: [],
    manager: {},
    subManagers: [],
    employees: [],
    teams: [],

    showManageAccessModal: false,
    showBillingModal: false,

    newManagerAppAccessFormData: {
      manager_id: null,
      safelyio_app_id: null,
      features_access_type: null,
      group_talk_sign_off_method: null,
      team_size_limit: null,
      start_date: null,
      end_date: null,
      sub_admin_limit: null,
      is_allowed_subadmin_feature: "no",
      has_access: "yes",
    },

    toolboxTalkFeatureAccessOptions: [
      {
        id: 1,
        name: "Only will have access to STANDARD TALKS features",
        type: "standard_talks",
      },

      {
        id: 2,
        name: "Only will have access to GROUP TALKS features",
        type: "group_talks",
      },

      {
        id: 3,
        name: "Both features",
        type: "both",
      },
    ],

    groupTalkSignOffFeatures: [
      {
        id: 1,
        name: "Checkoff",
        type: "checkoff",
      },

      {
        id: 2,
        name: "Digital Signatures",
        type: "digital_signatures",
      },

      {
        id: 3,
        name: "Photo of sign-in sheet",
        type: "photo_of_sheet",
      },

      {
        id: 4,
        name: "All sign-off methods",
        type: "all_signoff_methods",
      },
    ],

    apps: [],

    tabs: [
      {
        id: 1,
        name: "Apps List",
        type: "apps_list",
      },
      {
        id: 2,
        name: "Employees",
        type: "employees",
      },
    ],

    currentTab: "apps_list",

    appAccessList: [],

    showEditAppAccessModal: false,

    currentAppAccess: {},

    showBulkUploadEmployeesModal: false,

    newBulkUpload: {
      company_id: null,
      team_id: null,
      file: null,
      backlog_start_date: null,
      show_standard_talks_backlog_option: "no",
    },

    isLoading: false,

    newUsersEnrollToOldTalksFormData: {
      company_id: null,
      backlog_start_date: null,
    },

    showBacklogDateModal: false,

    newSupervisorsEnrollToOldTalksFormData: {
      company_id: null,
      backlog_start_date: null,
    },

    showSupervisorBacklogDateModal: false,

    showAddEMployeesToSupervisorTeamModal: false,

    newBulkUploadEmployeesToSupervisorTeam: {
      company_id: null,
      team_id: null,
      file: null,
    },

    showUpdateUserEmailModal: false,

    currentEmployee: {},

    toolboxTalkFormData: {
      language: "English",
      prompt: null,
    },

    showPromptInputModal: false,

    languagesArray: [
      { id: 1, name: "English", type: "english" },
      { id: 2, name: "Spanish", type: "spanish" },
    ],

    theAIGenerateTalk: {},

    showResultModal: false,

    showEmailListSearchModal: false,
    showEmailListResultsModal: false,

    checkedEmails: [],

    isDeleting: false,

    showSupervisorListModal: false,

    supervisors: [],
    groupTalkCampaigns: [],

    showSelectSupervisorsListModal: false,

    enrollSupervisorsList: [],

    showSelectCampaginsModal: false,
    currentSupervisor: null,

    errorsMessagesArray: [],

    group_talk_campaign_id: null,


  }),

  actions: {
    fetchAllTalks() {
      SuperAdminService.getAllTalksByAdmin()
        .then((response) => {
          this.talks = response.data.talks;

          // // eslint-disable-next-line no-console
          // console.log(response.data)
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },

    openCreateNewTalkModal() {
      this.showCreateNewTalkModal = true;
    },

    closeCreateNewTalkModal() {
      this.showCreateNewTalkModal = false;
    },

    // saveTalk() {

    //   SuperAdminService.saveTalkToDB(this.post)
    //     .then((response) => {

    //       toast("saved!", {
    //         position: "bottom-right",
    //         autoClose: 1000,
    //       });

    //       this.post.title = ""
    //       this.post.body = ""

    //       // // eslint-disable-next-line no-console
    //       // console.log(response.data);
    //     })
    //     .catch((err) => {
    //       // eslint-disable-next-line no-console
    //       console.log(err);
    //     });

    // },

    saveVideoTalk() {
      SuperAdminService.saveTalkToDB(this.videoPost)
        .then((response) => {
          toast("saved!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          this.videoPost.title = "";
          this.videoPost.video_embed_code = "";

          // // eslint-disable-next-line no-console
          // console.log(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },

    saveTextTalk() {
      SuperAdminService.updateTalk(this.textPost.id, this.textPost)
        .then((response) => {
          toast("updated!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          // // eslint-disable-next-line no-console
          // console.log(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },

    updateVideoTalk() {
      SuperAdminService.updateTalk(this.postDetails.id, this.postDetails)
        .then((response) => {
          toast("updated!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          // // eslint-disable-next-line no-console
          // console.log(response.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    },

    openVideoEmbedModal() {
      this.showVideoEmbedModal = true;
    },

    closeVideoEmbedModal() {
      this.showVideoEmbedModal = false;
    },

    setCurrentTalk(talk) {
      this.currentTalk = talk;
    },

    deleteTalk() {
      if (confirm("Are you sure you want to delete this talk?")) {
        SuperAdminService.deleteThisTalk(this.currentTalk.id)
          .then((response) => {
            this.fetchAllTalks();

            toast("deleted!", {
              position: "bottom-right",
              autoClose: 1000,
            });

            // // eslint-disable-next-line no-console
            // console.log(response.data)
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });

        console.log("delete talk");
      }
    },

    openShowPreviewTalkModal() {
      this.showPreviewTalkModal = true;
    },

    closeShowPreviewTalkModal() {
      this.showPreviewTalkModal = false;
    },

    fetchAllManagers() {
      SuperAdminService.getAllManagerAccounts()
        .then((response) => {
          this.managers = response.data;
          // console.log(response.data)
        })
        .catch((err) => {
          console.log(err);
        });
    },

    fetchAManager(uuid) {
      SuperAdminService.getAManagerAccountDetails(uuid)
        .then((response) => {
          this.manager = response.data.manager;
          this.subManagers = response.data.subManagers;
          this.employees = response.data.employees;
          this.apps = response.data.apps;
          this.appAccessList = response.data.appAccessList;
          this.teams = response.data.teams;

          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    formatDate(date) {
      return moment(date).format("MMM Do YYYY");
    },

    resetForm() {
      this.newManagerAppAccessFormData.manager_id = null;
      this.newManagerAppAccessFormData.safelyio_app_id = null;
      this.newManagerAppAccessFormData.features_access_type = null;
      this.newManagerAppAccessFormData.group_talk_sign_off_method = null;
      this.newManagerAppAccessFormData.team_size_limit = null;
      this.newManagerAppAccessFormData.start_date = null;
      this.newManagerAppAccessFormData.end_date = null;
      this.newManagerAppAccessFormData.sub_admin_limit = null;
      this.newManagerAppAccessFormData.is_allowed_subadmin_feature = "no";
      this.newManagerAppAccessFormData.has_access = "yes";
    },

    openManageAppAccessModal() {
      this.resetForm();
      this.showManageAccessModal = true;
    },

    closeManageAppAccessModal() {
      this.showManageAccessModal = false;
    },

    openBillingModal() {
      this.showBillingModal = true;
    },

    closeBillingModal() {
      this.showBillingModal = false;
    },

    addManagerAccessForApp() {
      this.newManagerAppAccessFormData.manager_id = this.manager.id;

      // console.log(this.newManagerAppAccessFormData)

      SuperAdminService.addAppAccess(this.newManagerAppAccessFormData)
        .then((response) => {
          if (response.data.message === "alreay_added") {
            alert(
              "This manager account was already added for this app's access!"
            );
          }

          if (response.data.message === "success") {
            toast("Success!", {
              position: "bottom-right",
              autoClose: 1000,
            });

            this.fetchAManager(this.manager.uuid);
            this.closeManageAppAccessModal();

            console.log(response.data);
          }

          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    toggleSubAdminFeature(stringValue) {
      this.newManagerAppAccessFormData.is_allowed_subadmin_feature =
        stringValue;
    },

    openShowEditAppAccessModal() {
      this.showEditAppAccessModal = true;
    },

    closeShowEditAppAccessModal() {
      this.showEditAppAccessModal = false;
    },

    setCurrentAppAccess(appAccess) {
      this.currentAppAccess = appAccess;
    },

    toggleNOSubAdminForEditModal() {
      this.currentAppAccess.is_allowed_subadmin_feature = "no";
      this.currentAppAccess.sub_admin_limit = null;
    },

    openBulkUploadEmployeesModal() {
      this.newBulkUpload.company_id = null;
      this.newBulkUpload.team_id = null;
      this.newBulkUpload.file = null;
      this.newBulkUpload.backlog_start_date = null;
      this.newBulkUpload.show_standard_talks_backlog_option = "no";

      this.showBulkUploadEmployeesModal = true;
    },

    closeBulkUploadEmployeesModal() {
      this.showBulkUploadEmployeesModal = false;
    },

    triggerInput() {
      let input = document.createElement("input");
      input.type = "file";
      input.accept =
        ".xls, .xlsx, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv";

      input.onchange = () => {
        let files = Array.from(input.files); // Correctly accessing files

        this.newBulkUpload.file = files[0];

        console.log(files[0]);
      };

      input.click();
    },

    uploadEmployeesInBulk() {
      this.isLoading = true;

      if (this.newBulkUpload.file === null) {
        alert("Upload the excel file first!");

        this.isLoading = false;

        return;
      }

      if (this.newBulkUpload.team_id === null) {
        alert("Select a team");

        this.isLoading = false;

        return;
      }

      if (
        this.newBulkUpload.show_standard_talks_backlog_option === "yes" &&
        this.newBulkUpload.backlog_start_date === null
      ) {
        alert("Select a backlog start date");

        this.isLoading = false;

        return;
      }

      if (
        confirm(
          "Are you sure all emails are valid? Once this process starts it cannot be undone. Please make sure the email list is cleaned before proceding."
        )
      ) {
        const formData = {
          company_id: this.manager.id,
          team_id: this.newBulkUpload.team_id,
          file: this.newBulkUpload.file,
          show_standard_talks_backlog_option:
            this.newBulkUpload.show_standard_talks_backlog_option,
          backlog_start_date: this.newBulkUpload.backlog_start_date,
        };

        SuperAdminService.processExcelFile(formData)
          .then((response) => {
            this.isLoading = false;
            this.closeBulkUploadEmployeesModal();

            toast("File was sent for processing!", {
              position: "bottom-right",
              autoClose: 1000,
            });

            console.log(response.data);
          })
          .catch((err) => {
            this.isLoading = false;

            console.log(err);
          });

        // console.log(formData)
      }
    },

    saveAppAccessUpdate() {
      const formData = {
        manager_id: this.currentAppAccess.manager_id,
        safelyio_app_id: this.currentAppAccess.safelyio_app_id,
        features_access_type: this.currentAppAccess.features_access_type,
        sign_off_method: this.currentAppAccess.sign_off_method,
        team_size_limit: this.currentAppAccess.team_size_limit,
        start_date: this.currentAppAccess.start_date,
        end_date: this.currentAppAccess.end_date,
        sub_admin_limit: this.currentAppAccess.sub_admin_limit,
        is_allowed_subadmin_feature:
          this.currentAppAccess.is_allowed_subadmin_feature,
        has_access: this.currentAppAccess.has_access,
      };

      // console.log(formData)

      SuperAdminService.updateAppAccess(formData, this.currentAppAccess.uuid)
        .then((response) => {
          this.closeShowEditAppAccessModal();

          toast("saved!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          // console.log(response.data)
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteThisAppAccess() {
      if (
        confirm(
          "Are you sure you want to delete this app access? both manager and employees will no longer see the app on the apps page!"
        )
      ) {
        const formData = {
          app_access_id: this.currentAppAccess.id,
        };

        SuperAdminService.deleteAppAccess(formData)
          .then((response) => {
            this.fetchAManager(this.manager.uuid);
            this.closeShowEditAppAccessModal();
            this.currentAppAccess = {};

            console.log(response.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // console.log(this.currentAppAccess)
      }
    },

    toggleStandardBacklogOption() {
      if (this.newBulkUpload.show_standard_talks_backlog_option === "yes") {
        this.newBulkUpload.show_standard_talks_backlog_option = "no";
      } else {
        this.newBulkUpload.show_standard_talks_backlog_option = "yes";
      }
    },

    openBacklogDateModal() {
      this.newUsersEnrollToOldTalksFormData.backlog_start_date = null;
      this.showBacklogDateModal = true;
    },

    closeBacklogDateModal() {
      this.showBacklogDateModal = false;
    },

    enrollNewUserToBacklogTalksStandard() {
      this.isLoading = true;

      const formData = {
        company_id: this.manager.id,
        backlog_start_date:
          this.newUsersEnrollToOldTalksFormData.backlog_start_date,
      };

      SuperAdminService.enrollNewUsersOnStandardTalksToAlreadyScheduledTalks(
        formData
      )
        .then((response) => {
          this.closeBacklogDateModal();
          this.isLoading = false;

          toast("Enrolled!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          console.log(response.data);
        })
        .catch((err) => {
          this.isLoading = false;

          console.log(err);
        });
    },

    openAddEMployeesToSupervisorTeamModal() {
      this.newBulkUploadEmployeesToSupervisorTeam.company_id = null;
      this.newBulkUploadEmployeesToSupervisorTeam.team_id = null;
      this.newBulkUploadEmployeesToSupervisorTeam.file = null;

      this.showAddEMployeesToSupervisorTeamModal = true;
    },

    closeAddEMployeesToSupervisorTeamModal() {
      this.showAddEMployeesToSupervisorTeamModal = false;
    },

    triggerSupervisorTeamListInput() {
      let input = document.createElement("input");
      input.type = "file";
      input.accept =
        ".xls, .xlsx, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv";

      input.onchange = () => {
        let files = Array.from(input.files); // Correctly accessing files

        this.newBulkUploadEmployeesToSupervisorTeam.file = files[0];

        console.log(files[0]);
      };

      input.click();
    },

    uploadEmployeesToSupervisorTeamInBulk() {
      this.isLoading = true;

      if (this.newBulkUploadEmployeesToSupervisorTeam.file === null) {
        alert("Upload the excel file first!");

        this.isLoading = false;

        return;
      }

      if (this.newBulkUploadEmployeesToSupervisorTeam.team_id === null) {
        alert("Select the supervisor team");

        this.isLoading = false;

        return;
      }

      if (confirm("Are you sure each row are filled properly?")) {
        const formData = {
          company_id: this.manager.id,
          team_id: this.newBulkUploadEmployeesToSupervisorTeam.team_id,
          file: this.newBulkUploadEmployeesToSupervisorTeam.file,
        };

        SuperAdminService.processExcelFileToAddNewEmployeesToSupervisorTeam(
          formData
        )
          .then((response) => {
            this.isLoading = false;
            this.closeAddEMployeesToSupervisorTeamModal();

            toast("File was sent for processing!", {
              position: "bottom-right",
              autoClose: 1000,
            });

            console.log(response.data);
          })
          .catch((err) => {
            this.isLoading = false;

            console.log(err);
          });

        console.log(formData);
      }
    },

    setCurrentUser(employee) {
      this.currentEmployee = employee;
    },

    openUpdateUserEmailModal(employee) {
      this.setCurrentUser(employee);
      this.showUpdateUserEmailModal = true;
    },

    closeUpdateUserEmailModal() {
      this.showUpdateUserEmailModal = false;
    },

    updateUserInfo() {
      if (
        !this.currentEmployee.fname ||
        !this.currentEmployee.lname ||
        !this.currentEmployee.email
      ) {
        alert("Make sure all required fields are filled!");
        return;
      }

      const formData = {
        current_user: this.currentEmployee,
      };

      SuperAdminService.updateUserInfoService(formData)
        .then((response) => {
          this.closeUpdateUserEmailModal();

          this.currentEmployee.name =
            this.currentEmployee.fname + " " + this.currentEmployee.lname;

          toast("User updated!", {
            position: "bottom-right",
            autoClose: 1000,
          });

          // console.log(response.data)
        })
        .catch((err) => {
          console.log(err);
        });

      // console.log(formData);
    },

    openPromptInputModal() {
      this.toolboxTalkFormData.language = "English";
      this.toolboxTalkFormData.prompt = null;

      this.showPromptInputModal = true;
    },

    closePromptInputModal() {
      this.toolboxTalkFormData.language = "English";
      this.toolboxTalkFormData.prompt = null;

      this.showPromptInputModal = false;
    },

    generateTalk() {
      this.isLoading = true;

      if (
        this.toolboxTalkFormData.language == null ||
        this.toolboxTalkFormData.prompt == null
      ) {
        alert(
          "Please select a language and make sure to describe what of takl should be created"
        );

        this.isLoading = false;

        return;
      }

      const formData = {
        promptContent: this.toolboxTalkFormData,
      };

      SuperAdminService.adminAIGenerateTalkService(formData)
        .then((response) => {
          this.theAIGenerateTalk = response.data.contentArray.talk;

          console.log(response.data);

          this.isLoading = false;
          this.openTalkResultModal();
        })
        .catch((err) => {
          console.log(err);

          this.isLoading = false;
        });

      console.log(formData);
    },

    openTalkResultModal() {
      this.showResultModal = true;
    },

    closeTalkResultModal() {
      this.showResultModal = false;
    },

    selectThisTalk() {
      this.post.title = this.theAIGenerateTalk.title;
      this.post.body = this.theAIGenerateTalk.body;

      this.closeTalkResultModal();
      this.closePromptInputModal();
    },

    exportTextAsPDF(talk) {
      const formData = {
        title: talk.title,
        body: talk.body,
      };

      console.log(formData);

      SuperAdminService.downloadSafetyTalkTextAsPDFService(formData)
        .then((response) => {
          // Create a blob from the response
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = talk.title + ".pdf";
          link.click();

          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openEmailListSearchModal() {
      this.showEmailListSearchModal = true;
    },

    closeEmailListSearchModal() {
      this.showEmailListSearchModal = false;
    },

    checkEmailListStatusinDB(uniqueEmails) {
      const formData = {
        emails: uniqueEmails,
      };

      SuperAdminService.checkEmailListStatusinDBForSuperAdminService(formData)
        .then((response) => {
          this.checkedEmails = response.data.checked_emails;

          this.openEmailListResultsModal();

          console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    openEmailListResultsModal() {
      this.showEmailListResultsModal = true;
    },

    closeEmailListResultsModal() {
      this.showEmailListResultsModal = false;
    },

    updateCurrentEmail(checkedEmail) {
      // console.log(checkedEmail)
      //if the status id true/1 switch to false
      if (checkedEmail.is_checked) {
        checkedEmail.is_checked = 0;
      } else {
        checkedEmail.is_checked = 1;
      }
    },

    atleastOneEmailMustBeSelectedCheck() {
      const hasCheckedEmail = this.checkedEmails.some(
        (email) => email.is_checked === 1
      );

      if (!hasCheckedEmail) {
        alert("Please select at least one email");
        return false;
      }

      return true;
    },

    deleteSoftDeletedEmailsForeverList() {
      if (this.atleastOneEmailMustBeSelectedCheck()) {
        this.isDeleting = true;

        const emailList = [];

        this.checkedEmails.forEach((email) => {
          if (email.is_checked === 1) {
            emailList.push(email);
          }
        });

        const formData = {
          emails_to_delete: emailList,
        };

        SuperAdminService.deleteSoftDeletedEmailsForeverService(formData)
          .then((response) => {
            this.isDeleting = false;

            this.checkedEmails = [];
            this.closeEmailListResultsModal();

            toast("Emails deleted permanently!", {
              position: "bottom-right",
              autoClose: 1000,
            });

            // console.log(response.data)
          })
          .catch((err) => {
            this.isDeleting = false;

            console.log(err);
          });
      }
    },

    openSupervisorBacklogDateModal() {
      this.newSupervisorsEnrollToOldTalksFormData.backlog_start_date = null;
      this.showSupervisorBacklogDateModal = true;
    },

    closeSupervisorBacklogDateModal() {
      this.showSupervisorBacklogDateModal = false;
    },

    // enrollNewSupervisorsToBacklogGroupTalks() {
    //   this.isLoading = true;

    //   const formData = {
    //     company_id: this.manager.id,
    //     backlog_start_date:
    //       this.newSupervisorsEnrollToOldTalksFormData.backlog_start_date,
    //   };

    //   // console.log(formData)

    //   SuperAdminService.enrollNewSupervisorsOnGroupTalksToAlreadyScheduledTalksService(
    //     formData
    //   )
    //     .then((response) => {

    //       this.closeSupervisorBacklogDateModal();
    //       this.isLoading = false;

    //       toast("Enrolled!", {
    //         position: "bottom-right",
    //         autoClose: 1000,
    //       });

    //       console.log(response.data);
    //     })
    //     .catch((err) => {
    //       this.isLoading = false;

    //       console.log(err);
    //     });

    // },



    openSupervisorListModal() {
      this.fetchDataToEnrollNewSupervisors()
      this.showSupervisorListModal = true
    },

    closeSupervisorListModal() {
      this.showSupervisorListModal = false
    },


    openSelectSupervisorsModal() {
      this.showSelectSupervisorsListModal = true
    },

    closeSelectSupervisorsModal() {
      this.showSelectSupervisorsListModal = false
    },

    updateSupervisorsList(supervisor) {

      const existsIndex = this.enrollSupervisorsList.findIndex(
        (s) => s.id === supervisor.id
      );

      if (existsIndex !== -1) {
        // already exists → remove
        this.enrollSupervisorsList.splice(existsIndex, 1);
        supervisor.is_checked = 0;


      } else {

        // not in list → add
        this.enrollSupervisorsList.push(supervisor);
        supervisor.is_checked = 1;

      }
    },

    formatDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },


    fetchDataToEnrollNewSupervisors() {

      //reset 
      this.enrollSupervisorsList = [];
      this.supervisors = [];
      this.groupTalkCampaigns = [];

      const formData = {
        manager_id: this.manager.id
      }

      // console.log(formData)

      SuperAdminService.getDataToEnrollNewSupervisorsService(formData)
        .then((response) => {

          this.supervisors = response.data.supervisors
          this.groupTalkCampaigns = response.data.groupTalkCampaigns

          console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });

    },


    openSelectCampaginsModal(enrolledSup) {
      this.currentSupervisor = enrolledSup
      this.showSelectCampaginsModal = true
    },

    closeSelectCampaginsModal() {
      this.showSelectCampaginsModal = false
    },


    updateCurrentSupervisorCampaignSelection(camp) {

      if (camp.is_checked) {
        camp.is_checked = 0;
      } else {
        camp.is_checked = 1;
      }
    },


    validateInputsForSupervisorsEnrollment() {
      const errors = [];

      this.enrollSupervisorsList.forEach((sup) => {

        const selectedCampaigns = sup.group_campaigns.filter(
          (camp) => camp.is_checked === 1
        );

        // ❗ must select at least one campaign
        if (selectedCampaigns.length === 0) {
          errors.push(`${sup.name}: select at least one campaign`);
          return; // skip further checks for this supervisor
        }

        // ❗ each selected campaign must have a date
        selectedCampaigns.forEach((camp) => {
          if (!camp.backlog_start_date) {
            errors.push(
              `${sup.name} → ${camp.name}: backlog date required`
            );
          }
        });
      });

      if (errors.length) {
        alert(errors.join("\n"));
        return false;
      }

      return true;
    },

    finallyEnrollNewSupervisors() {

      if (!this.validateInputsForSupervisorsEnrollment()) return;


      this.isLoading = true;

      const formData = {
        company_id: this.manager.id,
        enrollSupervisorsList: this.enrollSupervisorsList
      };

      SuperAdminService.enrollNewSupervisorsOnGroupTalksToAlreadyScheduledTalksService(formData)
        .then((response) => {

          this.closeSupervisorListModal();
          this.isLoading = false;

          toast("Enrolled!", {
            position: "bottom-right",
            autoClose: 1000,
          });


          console.log(response.data)

        }).catch((err) => {

          this.isLoading = false;

          console.log(err)

        });

      // console.log(formData);
    },


    sendMasterAccountWelcomeEmail() {

      const formData = {
        manager: this.manager
      }

      SuperAdminService.sendMasterAccountWelcomeEmailService(formData)
        .then((response) => {


          toast("Email sent successfully!", {
            position: "top-right",
            autoClose: 2000,
          });

          console.log(response.data)

        }).catch((err) => {

          toast.error("Error: Email sending failed!", {
            position: toast.POSITION.TOP_RIGHT,
          });

          console.log(err)

        });

    },


    recoverDeletedGroupTalkCampaign(){

      const formData = {
        group_talk_campaign_id: this.group_talk_campaign_id
      }

      GroupTalkService.recoverDeletedDataForAGroupTalkCampaignService(formData)
        .then((response) => {


          let message = response.data.message

          toast(message, {
            position: "bottom-right",
            autoClose: 1000,
          });

          this.group_talk_campaign_id = null

          
          
        }).catch((err) => {

            const message = err.response?.data?.message || "An unexpected error occurred. Please try again.";

            toast.error(message, {
              position: toast.POSITION.TOP_RIGHT, // Options: TOP_LEFT, BOTTOM_RIGHT, etc.
              autoClose: 3000,                   // Closes automatically after 3 seconds
              theme: 'colored',                  // Options: 'light', 'dark', 'colored'
            });

            this.group_talk_campaign_id = null

          console.log(err)
          
        });

    


    }












  },
});
